import React from 'react';
import { ContentState } from 'draft-js';

import { Emoji } from 'Shared/components/EmojiMartComponents';

import './EmojiComponent.scss';

type Props = {
  entityKey: string;
  children: React.ReactNode;
  contentState?: ContentState;
  mention?: {};
};

const EmojiComponent = ({ entityKey, contentState, children, mention }: Props) => {
  const emoji = mention || contentState.getEntity(entityKey).getData().emoji;

  return (
    <div className="emoji-component" contentEditable={false}>
      <Emoji emoji={emoji} size={21}>
        {children}
      </Emoji>
    </div>
  );
};

export default EmojiComponent;
